import React, { Component } from "react";
import "./DeletePackage.scss";
import Button, { BUTTON_DISPLAY } from "@acadia-ui/button";
import Modal from "@acadia-ui/modal";
import BookFiltersStore from "../../Flux/Stores/BookFiltersStore";
import MasterCampaignsStore from "../../Flux/Stores/MasterCampaignsStore";
import { deletePackages } from "../../Flux/Actions/PackagesActions";
import PackagesDataStore from "../../Flux/Stores/PackagesDataStore";
import PlacementDataStore from "../../Flux/Stores/PlacementDataStore";
import { fetchWithAuthPost } from "../../Flux/FetchWithAuth";
import ErrorHelpers from "../../Components/FormBuilder/ErrorHelpers";
import AppConfig from "../../AppConfig";

class DeletePackage extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	closeModal = () => {
		Modal.hide("deletePackagesModal");
	};

	sendDeleteObject = () => {
		const deletePackageRequests = [];
		let placementsDeleted = false;
		this.props.data.forEach((packageData) => {
			const postObject = this.formDataObjForDelete(packageData);
			const hasChildPlacements = packageData.ChildCount !== "0";
			if (postObject) {
				deletePackageRequests.push(
					fetchWithAuthPost(`${AppConfig.getBookApiBasePath().ApiBasePath}/plook/PackageSaveViewModel/DeletePackage`, JSON.stringify(postObject)).catch((error) =>
						ErrorHelpers.displayErrorToasts(error, "workbookToasts", "Package could not be deleted. It may be in use.")
					)
				);
				if (hasChildPlacements) {
					placementsDeleted = true;
					PlacementDataStore.deletePlacementsInPackage(packageData.PackageID);
				}
			}
		});
		this.props.onDelete((onSuccess) => {
			deletePackages(deletePackageRequests, placementsDeleted, this.props.onFailure).then(onSuccess);
		});
	};

	formDataObjForDelete = (packageData) => {
		const contextValues = BookFiltersStore.getContextValues();
		const filters = BookFiltersStore.getChoicesState();
		const campaignUniqueID = MasterCampaignsStore.getParentCampaignUniqueID();
		/* Config will hold the ID's of the filters */
		const MasterAgencyDivisionName = contextValues.agency?.name;
		const MasterBusinessUnitName = contextValues.client?.name;
		const MasterCountryCode = contextValues.country?.id;
		const MasterRegionCode = contextValues.region?.id;
		const PlatformID = filters.platform.value;
		const AuditLevelID = this.props.auditLevelData.find(({ AuditLevelName }) => AuditLevelName == "Package")?.AuditLevelID;
		const formSubmissionObj = {
			MasterAgencyDivisionName,
			MasterBusinessUnitName,
			MasterRegionCode,
			MasterCountryCode,
			PlatformID,
			AuditLevelID,
			ContextID: contextValues.contextId,
			CampaignUniqueIDCode: campaignUniqueID,
			// add here
			PackageData: { PackageID: packageData.PackageID },
			MetaData: [],
			TaxonomyData: []
		};
		return formSubmissionObj;
	};

	renderPackageInformation = () => {
		const packageInformation = [];
		this.props.data.forEach((packageInfo) => {
			packageInformation.push(
				<div className="packageInfoRow">
					<span className="packageInfo">{packageInfo.PackageName_Friendly}</span>
					<span className="packageInfo">{packageInfo.ChildCount}</span>
					<span className="packageInfo">{packageInfo.InNameSite}</span>
					<span className="packageInfo">{packageInfo.StartDate}</span>
					<span className="packageInfo">{packageInfo.EndDate}</span>
					<span className="packageInfo">{packageInfo.Cost}</span>
				</div>
			);
		});
		return packageInformation;
	};

	render() {
		return (
			<Modal
				id="deletePackagesModal"
				heading="Delete Package"
				description="The selected packages will be permanently deleted and cannot be undone."
				onRequestClose={this.closeModal}
				actionSetProps={{
					actionsRight: (
						<>
							<Button display={BUTTON_DISPLAY.SECONDARY} onClick={this.closeModal} data-tracking-id-alt="cancel-delete-package">
								Cancel
							</Button>
							<Button onClick={this.sendDeleteObject} data-tracking-id-alt="confirm-delete-package">
								Confirm
							</Button>
						</>
					)
				}}
				onClick={() => {}}
				size="large"
			>
				<div className="packageListContainer">
					<div className="packageListHeader">
						<span>Description</span>
						<span>Number of Placement</span>
						<span>Site</span>
						<span>Start Date</span>
						<span>End Date</span>
						<span>Cost</span>
					</div>
					{this.renderPackageInformation()}
				</div>
				{this.props.prismaAPIEnabled === true && (
					<p style={{ fontSize: "17px", marginTop: "5px", fontWeight: "bold" }}>Deleting a package in PM will automatically exclude in Prisma.</p>
				)}
			</Modal>
		);
	}
}

export default DeletePackage;
